/** @jsxImportSource @emotion/react */

import { MENU_USER_LAYOUT } from "constants/menu-user-layout";
import _map from "lodash/map";
import React from "react";
import { NavLink } from "react-router-dom";

import { HeaderUserLayoutStyle } from "./index.style";

const HeaderUserLayout = () => {
    return (
    <div css={HeaderUserLayoutStyle.wrapper}>
      <header css={HeaderUserLayoutStyle.self}>
        <h1 css={HeaderUserLayoutStyle.title}>{"會員中心"}</h1>
        <ul css={HeaderUserLayoutStyle.tabs}>
          {_map(MENU_USER_LAYOUT, (item, index) => (
            <React.Fragment key={index}>
              <li css={HeaderUserLayoutStyle.tabItem}>
                <NavLink to={item.path}>{item.name}</NavLink>
                <span></span>
              </li>

              {index < MENU_USER_LAYOUT.length - 1 && (
                <li css={HeaderUserLayoutStyle.line}></li>
              )}
            </React.Fragment>
          ))}
        </ul>
      </header>
    </div>
  );
};

export default HeaderUserLayout;
